import "../../../design/TableUI.css";
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API_URL } from "../../../api/API_SERVERS";
import { GrStatusGood } from "react-icons/gr";
import { MdOutlineGppBad } from "react-icons/md";
import { FaBookDead } from "react-icons/fa";
import Loading from "../../otherComponents/Loading";

export default function RequestingUsers() {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");

    // Memoized fetch function with no outer dependencies
    const getRequests = useCallback(async (targetPage, targetSearch) => {
        setLoading(true);
        try {
            const res = await axios.get(`${API_URL}/api/admin/waiting-teachers`, {
                params: {
                    page: targetPage,
                    limit: 10,
                    search: targetSearch || ""
                },
                headers: { Authorization: 'Bearer ' + localStorage.getItem('AdminToken') }
            });

            setRequests(res.data.teachers || []);
            setTotalPages(res.data.totalPages || 1);
        } catch (err) {
            console.error("Fetch error:", err);
        } finally {
            setLoading(false);
        }
    }, []);

    const handleAction = async (url, id) => {
        if (!window.confirm(`Are you sure you want to ${url} this user?`)) return;

        setLoading(true);
        try {
            await axios.put(`${API_URL}/api/admin/${url}/${id}`, {}, {
                headers: { Authorization: `Bearer ${localStorage.getItem("AdminToken")}` }
            });
            // Refresh using latest state securely
            getRequests(page, search);
        } catch (e) {
            console.error("Action error:", e);
        } finally {
            setLoading(false);
        }
    };

    // COMBINED EFFECT: Handled both search changes (debounced) and immediate page pagination changes
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            getRequests(page, search);
        }, 1000);

        return () => clearTimeout(delayDebounceFn);
    }, [page, search, getRequests]);

    return (
        <>
            {loading && <Loading />}
            <div className="ui-toolbar">
                <div className="ui-search-wrapper">
                    <input
                        className="ui-search-input"
                        placeholder="Search by Person ID..."
                        value={search}
                        onChange={(e) => {
                            setPage(1); // Reset page to 1 on new search keystroke
                            setSearch(e.target.value);
                        }}
                    />
                </div>

                {/* Pagination Controls */}
                <div className="ui-pagination-controls">
                    <button
                        className="ui-page-btn"
                        disabled={page === 1}
                        onClick={() => setPage(prev => prev - 1)}
                    >
                        Prev
                    </button>

                    <span style={{ fontWeight: 600, minWidth: '45px', textAlign: 'center' }}>
                        {page} / {totalPages}
                    </span>

                    <button
                        className="ui-page-btn"
                        disabled={page >= totalPages}
                        onClick={() => setPage(prev => prev + 1)}
                    >
                        Next
                    </button>
                </div>
            </div>

            <div className="ui-table-container">
                <table className="ui-custom-table">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Person ID</th>
                        <th>Address</th>
                        <th>Mobile</th>
                        <th>Date</th>
                        <th style={{ textAlign: 'center' }}>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {requests.length > 0 ? (
                        requests
                            .map((r) => (
                                <tr key={r.person_id}>
                                    <td style={{ fontWeight: 600 }}>{r.fullname}</td>
                                    <td style={{ color: 'var(--text-muted)' }}>{r.person_id}</td>
                                    <td style={{ color: 'var(--text-muted)' }}>{r.address}</td>
                                    <td>{r.mobile_number}</td>
                                    <td>{r.created_at?.split('T')[0]}</td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                            <button title="Approve" className="ui-icon-btn green" onClick={() => handleAction('promote', r.person_id)}><GrStatusGood /></button>
                                            <button title="Decline" className="ui-icon-btn red" onClick={() => handleAction('decline', r.person_id)}><MdOutlineGppBad /></button>
                                            <button title="Block" className="ui-icon-btn black" onClick={() => handleAction('block', r.person_id)}><FaBookDead /></button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                    ) : (
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
                                No pending requests found.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </>
    );
}